















import { Component, Mixins, Prop } from 'vue-property-decorator'
import TcwFormItemCommon from '@/components/common/form/mixins/TcwFormItemCommon'

@Component
export default class TcwFormItemLabel extends Mixins(TcwFormItemCommon) {
  @Prop({ default: '' })
  private value!: string
  @Prop({ type: Boolean, default: false })
  private strong!: boolean
}
